/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ExcellentInputs */

const en_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent`)
};

const es_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente`)
};

const fr_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent`)
};

const de_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgezeichnet`)
};

const ja_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に良い`)
};

const zh_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`极好`)
};

const ar_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ممتاز`)
};

const id_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sangat Baik`)
};

const it_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eccellente`)
};

const ru_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отличное`)
};

const pt_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente`)
};

const ko_val_excellent = /** @type {(inputs: Val_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매우 좋음`)
};

/**
* | output |
* | --- |
* | "Excellent" |
*
* @param {Val_ExcellentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_excellent = /** @type {((inputs?: Val_ExcellentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ExcellentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_excellent(inputs)
	if (locale === "es") return es_val_excellent(inputs)
	if (locale === "fr") return fr_val_excellent(inputs)
	if (locale === "de") return de_val_excellent(inputs)
	if (locale === "ja") return ja_val_excellent(inputs)
	if (locale === "zh") return zh_val_excellent(inputs)
	if (locale === "ar") return ar_val_excellent(inputs)
	if (locale === "id") return id_val_excellent(inputs)
	if (locale === "it") return it_val_excellent(inputs)
	if (locale === "ru") return ru_val_excellent(inputs)
	if (locale === "pt") return pt_val_excellent(inputs)
	return ko_val_excellent(inputs)
});